import { TextInput } from "@truevault/aquilo";
import React from "react";
import { Field, Form } from "react-final-form";
import { OrganizationDto } from "../../../common/service/server/dto/OrganizationDto";
import { requiredString } from "../../util/validation";

interface OrganiationNameFormProps {
  organization: OrganizationDto;
  updateOrganization: (values: any) => void;
}

const formValidation = (values) => {
  const errors = {} as any;

  requiredString(values, "name", errors);

  return errors;
};

export function OrganizationNameForm({
  organization,
  updateOrganization,
}: OrganiationNameFormProps) {
  return (
    <Form
      initialValues={organization}
      onSubmit={updateOrganization}
      validate={formValidation}
      render={({ handleSubmit }) => {
        return (
          <Field name="name">
            {({ input, meta }) => (
              <div className="tw-boundary org-name-input" style={{ maxWidth: 400, marginTop: 24 }}>
                <TextInput
                  field="name"
                  label="Organization name"
                  required
                  onBlur={(e) => {
                    input.onBlur(e);
                    handleSubmit();
                  }}
                />
                {meta.touched && meta.error && (
                  <p className="text-red-800 text-[12px]">{meta.error}</p>
                )}
              </div>
            )}
          </Field>
        );
      }}
    />
  );
}
